import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { ISystemParams } from '@core/interfaces/public.interface';
import { HttpClient } from '@angular/common/http';
import { cacheContext } from 'ngx-mt-ui-lib/cache';

@Injectable({
  providedIn: 'root',
})
export class PublicApiService {
  private readonly httpClient = inject(HttpClient);

  getPublicParameters(): Observable<ISystemParams> {
    return this.httpClient.get<ISystemParams>(
      `${environment.API_URL}/public/parameters`,
      { context: cacheContext() },
    );
  }
}
